import type { ReactNode } from "react";
import { vars } from "@pack-it-up/ui-web";
import { SearchIcon } from "../../app/icons.js";

// Compact search box (issue #83). A muted, icon-led field; its value is the caller's
// search query and clearing it (empty string) removes the filter. Shared by the list
// Toolbar and the Notes tab.
export const SearchField = ({
  value,
  onChange,
  placeholder,
}: {
  value: string;
  onChange: (query: string) => void;
  placeholder: string;
}): ReactNode => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      padding: `4px ${vars.space.sm}`,
      border: `1px solid ${vars.color.border}`,
      borderRadius: vars.radius.md,
      background: vars.color.surface,
      color: vars.color.textMuted,
    }}
  >
    {SearchIcon(13)}
    <input
      type="search"
      aria-label={placeholder}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{
        border: "none",
        outline: "none",
        background: "transparent",
        color: vars.color.text,
        font: "inherit",
        fontSize: vars.font.sizeXs,
        width: "150px",
        minWidth: 0,
      }}
    />
  </span>
);
